import React, { useState } from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import './Checkbox.scss';

function Checkbox({
    checked,
    onChange,
    label,
    disabled
}) {

    const [id] = useState(_.uniqueId());

    return <div className={classNames("checkbox", {disabled: disabled})}>
        <input type="checkbox" id={id} onChange={(ev) => onChange(ev.target.checked)} checked={checked} disabled={disabled} />
        <label htmlFor={id}>
            <span className="box">
                {checked && <div className="checked-img" />}
            </span>
            {label}
        </label>
    </div>;
}

export default Checkbox;